"use strict";
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var core_1 = require("@material-ui/core");
var react_i18next_1 = require("react-i18next");
var environment_variables_1 = require("../../../../shared/util/environment-variables");
var useStyles = core_1.makeStyles(function () {
    return core_1.createStyles({
        masthead: {
            zIndex: 2,
            position: function (props) {
                return props.isSticky && props.toStick ? 'absolute' : 'relative';
            },
            backgroundColor: '#FFD898',
            height: 'auto',
            padding: '4px 0',
            fontSize: '14px',
        },
        mastheadLink: {
            marginLeft: '30px',
            fontFamily: "'Noto Sans Khmer', sans-serif",
            color: '#a85d32',
            display: 'flex',
            alignItems: 'center',
            '&:hover': {
                textDecoration: 'underline',
            },
        },
        mastheadText: {
            margin: '0px auto',
        },
    });
});
var Masthead = function (_a) {
    var isSticky = _a.isSticky, toStick = _a.toStick;
    var _b = __read(react_i18next_1.useTranslation(), 1), t = _b[0];
    var classes = useStyles({ isSticky: isSticky, toStick: toStick });
    return (react_1.default.createElement(react_1.default.Fragment, null, environment_variables_1.ddEnv !== 'production' ? (react_1.default.createElement("div", { className: classes.masthead },
        react_1.default.createElement("a", { href: "https://go.gov.kh", target: "_blank", rel: "noopener noreferrer", className: classes.mastheadLink },
            react_1.default.createElement("span", { className: classes.mastheadText }, t('message.warning.devLabel'))))) : ('')));
};
exports.default = Masthead;
